import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Popup } from 'semantic-ui-react';
import _ from 'lodash';

const resolveAssetPlatform = platform => {
  const icons = {
    INSTAGRAM: {
      name: 'instagram',
      color: 'pink',
      label: 'Instagram',
    },
    VK: {
      name: 'vk',
      color: 'blue',
      label: 'VK',
    },
    SNAPCHAT: {
      name: 'snapchat',
      color: 'yellow',
      label: 'Snapchat',
    },
    FACEBOOK: {
      name: 'facebook',
      color: 'blue',
      label: 'Facebook',
    },
    TWITTER: {
      name: 'twitter',
      color: 'blue',
      label: 'Twitter',
    },
    BLOG: {
      name: 'pencil',
      color: 'gray',
      label: 'Blog',
    },
  };
  return _.get(icons, platform);
};

const resolveAssetTypeIcon = assetType => {
  const icons = {
    STORY: {
      iconName: 'circle',
      label: 'Story',
    },
    VIDEO: {
      iconName: 'youtube play',
      label: 'Video',
    },
    IMAGE: {
      iconName: 'picture',
      label: 'Image',
    },
    TEXT: {
      iconName: null,
      label: 'post',
    },
  };
  return _.get(icons, assetType);
};

const AssetTypeIcon = ({
  asset,
  renderLabelAsText,
}) => {
  if (_.isNil(_.get(asset, 'type'))) {
    return null;
  }
  const primaryIcon = resolveAssetPlatform(_.get(asset, 'platform'));
  const secondaryIcon = resolveAssetTypeIcon(_.get(asset, 'assetType'));
  return (
    <Popup
      trigger={
        <div>
          <Icon name={primaryIcon.name} color={primaryIcon.color} />
          {
            secondaryIcon && secondaryIcon.iconName &&
            <Icon
              name={secondaryIcon.iconName}
              color={primaryIcon.color}
            />
          }
          {
            renderLabelAsText && <span>{primaryIcon.label} {secondaryIcon.label}</span>
          }
        </div>
      }
      content={`${primaryIcon.label} ${secondaryIcon.label}`}
    />
  );
};

AssetTypeIcon.propTypes = {
  asset: PropTypes.object.isRequired,
  renderLabelAsText: PropTypes.bool,
};

AssetTypeIcon.defaultProps = {
  renderLabelAsText: false,
};

export default AssetTypeIcon;



/** WEBPACK FOOTER **
 ** ./src/components/asset-type-icon/index.js
 **/